import React from "react";
import { useLocation  } from "react-router-dom";
import logo from "../assets/logo.png"; // 로고 이미지 경로
import style from "./Header.module.css"

function Header() {
  const location = useLocation();
    return (
      <header className={style.header}>
        <div className={style.logo}>
          <a href ="https://cheumad.kr/"><img src={logo} alt="채움기획 로고" /></a>
        </div>
        <nav id="nav" aria-label="Primary">
          <ul>
            <li><a href ="/" className={location.pathname === "/" ? style.active : ""}>회사소개</a></li>
            <li><a href ="/portfolio" className={location.pathname === "/portfolio" ? style.active : ""}>포트폴리오</a></li>
            <li><a href="/contact" className={location.pathname === "/contact" ? style.active : ""}>찾아오시는 길</a></li>
          </ul>
        </nav>
      </header>
    );
}

export default Header